import { render, staticRenderFns } from "./LaunchWeapp.vue?vue&type=template&id=2080ffe5&"
import script from "./LaunchWeapp.vue?vue&type=script&lang=ts&"
export * from "./LaunchWeapp.vue?vue&type=script&lang=ts&"
import style0 from "./LaunchWeapp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports